import React from 'react';
import { Box } from '@wix/design-system';
import { FaqItem } from './FaqItem';
export const FaqList = ({ faq, onClickFaqItem }) => {
    return (React.createElement(Box, { direction: "vertical", cursor: "pointer", width: "100%" }, faq.map((faqItem, index) => (React.createElement(FaqItem, { key: index, onClickFaqItem: onClickFaqItem, isFirst: index === 0, ...faqItem })))));
};
//# sourceMappingURL=FaqList.js.map